const fromRefcode = state => state.auth.fromRefcode;

const accessToken = state => state.auth.accessToken;
const accessExpires = state => state.auth.accessExpires;

const isAuthorized = state => state.auth.isAuthorized;

const loginStatus = state => state.auth.loginStatus;
const loginClientId = state => state.auth.loginClientId;
const signupStatus = state => state.auth.signupStatus;
const forgotPwStatus = state => state.auth.forgotPwStatus;
const resetTokenStatus = state => state.auth.resetTokenStatus;
const resetPwStatus = state => state.auth.resetPwStatus;

export default {
  fromRefcode,

  accessToken,
  accessExpires,

  isAuthorized,

  loginStatus,
  loginClientId,
  signupStatus,
  forgotPwStatus,
  resetTokenStatus,
  resetPwStatus,
};
